import _ from 'lodash'

import machineServer from '../../../../Server'
import fieldHelpers from '../../../../../../ui-formly/fieldHelpers/index'
import PreviousFieldController from '../../../../../common/ui-formly/controllers/PreviousFieldController'
import authService from '../../../../../../user/authorization/authService'

function formly(authService) {
  var fields = [
    {
      className: 'row',
      fieldGroup: [{
        ...fieldHelpers.simpleDateField({ key: 'Date', required: true, label: 'Date' }),
        className: 'col-xs-4'
      },
      {
        key: 'btn',
        template: '<button type="button" class="btn btn-primary" ng-click="copyLastLocation()"><i class="fa fa-clone" />&nbsp;Last Location</button>',
        controller: ['$scope', function ($scope) {
          $scope.copyLastLocation = () => {
            const model = $scope.model
            model.MachineAreaId = model.PreviousMachineAreaId
            model.MachineAreaName = model.PreviousMachineAreaName
            model.Section = model.PreviousSection
            model.Bank = model.PreviousBank
            model.Slot = model.PreviousSlot
            model.MachineBankConfigId = model.PreviousMachineBankConfigId
            model.MachineBankConfigName = model.PreviousMachineBankConfigName
          }
        }],
        className: 'pull-right col-xs-2'
      }]
    },
    fieldHelpers.columnLayout(
      [
        {
          key: "MachineAreaId",
          name: "MachineAreaId",
          type: "selectAsync",
          className: 'attention',
          templateOptions: {
            label: "Area",
            required: true,
            showAddButton: authService.hasPermission('machineEdit'),
            query: [machineServer.vsName, function (server) {
              return function (search) {
                return server.machineAreaQuery({
                  NameContains: search,
                  Skip: 0,
                  Take: 25,
                  OrderBy: 'Name'
                })
              }
            }],
            saveNewItem: [machineServer.vsName, function (server) {
              return function (name) {
                return server.machineAreaSave({
                  Name: name
                })
              }
            }],
            getDefaultItem: function (model) {
              return {
                Id: model.MachineAreaId,
                Name: model.MachineAreaName
              }
            },
            updateNameProp: 'MachineAreaName'
          },
          expressionProperties: {
            'templateOptions.helpText': ($viewValue, $modelValue, $scope) => {
              return `Previous: ${$scope.model.PreviousMachineAreaName}`
            }
          }
        },
        inputFieldWithPrevious({ key: 'Section', label: 'Section', required: true }),
        inputFieldWithPrevious({ key: 'Bank', label: 'Bank', required: true }),
        inputFieldWithPrevious({ key: 'Slot', label: 'Slot', required: true }),
        {
          key: "MachineBankConfigId",
          name: "MachineBankConfigId",
          type: "selectAsync",
          className: 'attention',
          templateOptions: {
            label: "Bank Config",
            required: true,
            showAddButton: authService.hasPermission('machineEdit'),
            query: [machineServer.vsName, function (server) {
              return function (search) {
                return server.machineBankConfigQuery({
                  NameContains: search,
                  Skip: 0,
                  Take: 25,
                  OrderBy: 'Name'
                })
              }
            }],
            saveNewItem: [machineServer.vsName, function (server) {
              return function (name) {
                return server.machineBankConfigSave({
                  Name: name
                })
              }
            }],
            getDefaultItem: function (model) {
              return {
                Id: model.MachineBankConfigId,
                Name: model.MachineBankConfigName
              }
            },
            updateNameProp: 'MachineBankConfigName'
          },
          expressionProperties: {
            'templateOptions.helpText': ($viewValue, $modelValue, $scope) => {
              return `Previous: ${$scope.model.PreviousMachineBankConfigName}`
            }
          }
        }
      ], 3),
    {
      key: 'Files',
      name: 'Files',
      type: 'fileUpload',
      templateOptions: {
        label: 'Files'
      }
    },
    fieldHelpers.columnLayout(
      [
        {
          key: "Notes",
          name: "Notes",
          type: "textarea",
          templateOptions: {
            label: "Notes",
            rows: 5
          }
        }
      ], 1)
  ]

  return _.flatten(fields, false)
}

function inputFieldWithPrevious(config) {
  const field = {
    type: 'input',
    controller: PreviousFieldController,
    key: config.key,
    name: config.key,
    templateOptions: {
      label: config.label,
      required: config.required
    }
  }

  return field
}
formly.$inject = [authService.vsName]

export default formly
